import { render, staticRenderFns } from "./FileSystem.vue?vue&type=template&id=4eae2c64&scoped=true&"
import script from "./FileSystem.vue?vue&type=script&lang=js&"
export * from "./FileSystem.vue?vue&type=script&lang=js&"
import style0 from "./FileSystem.vue?vue&type=style&index=0&id=4eae2c64&scoped=true&lang=scss&"
import style1 from "./FileSystem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eae2c64",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VMenu})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4eae2c64')) {
      api.createRecord('4eae2c64', component.options)
    } else {
      api.reload('4eae2c64', component.options)
    }
    module.hot.accept("./FileSystem.vue?vue&type=template&id=4eae2c64&scoped=true&", function () {
      api.rerender('4eae2c64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/files/FileSystem.vue"
export default component.exports